/* eslint-disable */
import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import i18n from "../../i18n";
import { baseUri } from "../../uri";
import {
  GET_RISK_PROFILES,
  GET_ALL_RISK_CRITERIAS_CONFIGURATION,
  GET_ALL_RISK_CRITERIAS,
  UPDATE_RISK_CRITERIA_VALUES,
  ADD_CRITERIA,
  DELETE_CRITERIA,
  GET_QUESTIONS_BY_CRITERIA,
  GET_QUESTIONS_CONFIGURATION,
  GET_ALL_QUESTIONS_CONFIGURATION,
  UPDATE_RISK_PROFILES,
  DELETE_RISK_PROFILES,
  ADD_RISK_PROFILES,
  ADD_QUESTIONS_CONFIGURATION,
  DELETE_QUESTIONS_CONFIGURATION,
  EDIT_QUESTIONS_CONFIGURATION_VALUES,
} from "../actionTypes";

export const add_RiskProfiles = (riskProfile: any) => async (
  dispatch: (arg0: { type: any; payload: void }) => void
) => {
  try {
    const res = await axios.post(
      `${baseUri}/service-risk-profile/v1/configurations/risk-profiles`,
      riskProfile
    );
    dispatch({
      type: ADD_RISK_PROFILES,
      payload: res.data,
    });
  } catch (e) {
    toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};
export const delete_RiskProfiles = (riskProfileId: any) => async (
  dispatch: (arg0: { type: any; payload: void }) => void
) => {
  try {
    const res = await axios.delete(
      `${baseUri}/service-risk-profile/v1/configurations/risk-profiles/${riskProfileId}`
    );
    dispatch({
      type: DELETE_RISK_PROFILES,
      payload: res.data,
    });
  } catch (e) {
    toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};
export const update_RiskProfiles = (
  riskProfile: any,
  riskProfileId: any
) => async (dispatch: (arg0: { type: any; payload: void }) => void) => {
  try {
    const res = await axios.put(
      `${baseUri}/service-risk-profile/v1/configurations/risk-profiles/${riskProfileId}`,
      riskProfile
    );
    dispatch({
      type: UPDATE_RISK_PROFILES,
      payload: res.data,
    });
  } catch (e) {
    toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};
export const getAllRiskProfiles = () => async (
  dispatch: (arg0: { type: any; payload: void }) => void
) => {
  try {
    const res = await axios.get(
      `${baseUri}/service-risk-profile/v1/configurations/risk-profiles?unpaged?offset?paged?pageNumber?pageSize?sort.sorted?sort.unsorted`
    );
    dispatch({
      type: GET_RISK_PROFILES,
      payload: res.data,
    });
  } catch (e) {
    toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};

export const getAllRiskCriteriasConfigurations = () => async (
  dispatch: (arg0: { type: any; payload: void }) => void
) => {
  try {
    const res = await axios.get(
      `${baseUri}/service-risk-profile/v1/configurations/criterias?unpaged?offset?paged?pageNumber?pageSize?sort.sorted?sort.unsorted`
    );
    dispatch({
      type: GET_ALL_RISK_CRITERIAS_CONFIGURATION,
      payload: res.data,
    });
  } catch (e) {
    toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};

export const getAllRiskCriterias = () => async (
  dispatch: (arg0: { type: any; payload: void }) => void
) => {
  try {
    const res = await axios.get(
      `${baseUri}/service-risk-profile/v1/configurations/criteria-profiles?unpaged?offset?paged?pageNumber?pageSize?sort.sorted?sort.unsorted`
    );
    dispatch({
      type: GET_ALL_RISK_CRITERIAS,
      payload: res.data,
    });
  } catch (e) {
    toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};

export const update_riskConfigurationCriteriaValues = (
  criteria_weight: number,
  criteria_id: string
) => async (dispatch: (arg0: { type: string; payload: any }) => void) => {
  try {
    const res = await axios.put(
      `${baseUri}/service-risk-profile/v1/configurations/criterias/${criteria_id}`,
      { weight: criteria_weight }
    );
    console.groupEnd();
    dispatch({
      type: UPDATE_RISK_CRITERIA_VALUES,
      payload: res.data,
    });
  } catch (e) {
    toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};

export const add_criterias = (criteria: any) => async (
  dispatch: (arg0: { type: string; payload: any }) => void
) => {
  try {
    const res = await axios.post(
      `${baseUri}/service-risk-profile/v1/configurations/criteria-profiles`,
      criteria
    );
    dispatch({
      type: ADD_CRITERIA,
      payload: res.data,
    });
  } catch (e) {
    toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};

export const delete_criterias = (criteria_id: string) => async (
  dispatch: (arg0: { type: any; payload: any }) => void
) => {
  try {
    const res = await axios.delete(
      `${baseUri}/service-risk-profile/v1/configurations/criteria-profiles/${criteria_id}`
    );
    dispatch({
      type: DELETE_CRITERIA,
      payload: res.data,
    });
  } catch (e) {
    toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};

export const update_criteriaValue = (
  criteria: any,
  criteria_id: string
) => async (dispatch: (arg0: { type: string; payload: any }) => void) => {
  try {
    const res = await axios.put(
      `${baseUri}/service-risk-profile/v1/configurations/criteria-profiles/${criteria_id}`,
      criteria
    );
    dispatch({
      type: DELETE_CRITERIA,
      payload: res.data,
    });
  } catch (e) {
    toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};

export const get_questionsByCriteriaId = (criteria: any) => async (
  dispatch: (arg0: { type: string; payload: any }) => void
) => {
  try {
    const res = await axios.get(
      `${baseUri}/service-risk-profile/v1/configurations/criterias/${criteria.id}/questions`
    );
    dispatch({
      type: GET_QUESTIONS_BY_CRITERIA,
      payload: res.data,
    });
  } catch (e) {
    toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};
export const get_all_questions_configuration = (criteria: any) => async (
  dispatch: (arg0: { type: string; payload: any }) => void
) => {
  try {
    const res = await axios.get(
      `${baseUri}/service-risk-profile/v1/configurations/criterias/questions`
    );
    dispatch({
      type: GET_ALL_QUESTIONS_CONFIGURATION,
      payload: res.data,
    });
  } catch (e) {
    toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};

export const get_questions_configuration = (
  criteriaId: string,
  questionConfigurationId: string
) => async (dispatch: (arg0: { type: string; payload: any }) => void) => {
  try {
    const res = await axios.get(
      `${baseUri}/service-risk-profile/v1/configurations/criterias/${criteriaId}/questions/${questionConfigurationId}`
    );
    dispatch({
      type: GET_QUESTIONS_CONFIGURATION,
      payload: res.data,
    });
  } catch (e) {
    toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};
export const add_questions_configuration = (
  criteriaId: string,
  key: any
) => async (dispatch: (arg0: { type: string; payload: any }) => void) => {
  try {
    const res = await axios.post(
      `${baseUri}/service-risk-profile/v1/configurations/criterias/${criteriaId}/questions`,
      key
    );
    dispatch({
      type: ADD_QUESTIONS_CONFIGURATION,
      payload: res.data,
    });
  } catch (e) {
    toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};
export const delete_questions_configuration = (
  criteriaId: string,
  key: any
) => async (dispatch: (arg0: { type: string; payload: any }) => void) => {
  try {
    const res = await axios({
      method: "delete",
      url: `${baseUri}/service-risk-profile/v1/configurations/criterias/${criteriaId}/questions`,
      data: key,
    });
    dispatch({
      type: DELETE_QUESTIONS_CONFIGURATION,
      payload: res.data,
    });
  } catch (e) {
    toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};
export const edit_questions_configuration_values = (
  criteriaId: string,
  questionConfigurationId: string,
  values: any,
  value: string
) => async (dispatch: (arg0: { type: string; payload: any }) => void) => {
  try {
    const res = await axios.put(
      `${baseUri}/service-risk-profile/v1/configurations/criterias/${criteriaId}/questions/${questionConfigurationId}/values/${value}`,
      values
    );
    dispatch({
      type: EDIT_QUESTIONS_CONFIGURATION_VALUES,
      payload: res.data,
    });
  } catch (e) {
    toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};
